/* hs-eslint ignored failing-rules */
/* eslint-disable promise/catch-or-return */

'use es6';

import '../setupDispatcher';
import setup from '../setup';
import { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import { usePlatformDashboardDispatch } from 'platform-dashboard-ui/store';
import { fetchUserInfo } from 'platform-dashboard-ui/ducks/userInfoSlice';
import { Switch, Redirect } from 'react-router-dom';
import userInfo from 'hub-http/userInfo';
import { ShareToSlackPanelLoader } from 'slack-ui-library';
import PortalIdParser from 'PortalIdParser';
import AsyncSingleReportViewerModal from 'reporting-enablement/components/singleReportViewer/AsyncSingleReportViewerModal';
import { isNil } from 'dashboard-lib/private/js-util';
import { DASHBOARD_CLONE, DASHBOARD_REMOVE_REPORT, DASHBOARD_RENAME, DASHBOARD_SET_PERMISSION, REPORT_MOVE, VIEW_ACTIVITY_LOG, VIEW_DASHBOARD_DETAILS } from 'dashboard-lib/public/action/reporting-action';
import ReportingActionsLoader from 'reporting-action-components/reportingActions/ReportingActionsLoader';
import { REPORT_ACTION_DIALOGS, DASHBOARD_ACTION_DIALOGS } from 'reporting-action-components/dialog/dialogSets';
import { SINGLE_REPORT_VIEWER, EMAIL_DASHBOARD_DIALOG } from 'reporting-action-components/dialog/dialogTypes';
import { fetchUsers } from 'dashboard-lib/public/users/users-action';
import UserInfoContext from 'dashboard-components/context/user-info-context';
import AsyncDashboardDetailsPanel from './modals/AsyncDashboardDetailsPanel';
import AppActions from '../actions/AppActions';
import { fetchUserAttributes } from '../actions/SettingsActions';
import { RouteConfigs } from '../constants/route/DashboardRoute';
import { parseAsQueryMap } from '../lib/historyUtils';
import { createDashboardRoute } from '../lib/routes';
import { showApplicationMessages } from '../lib/showApplicationMessages';
import store from '../stores/ReduxStore';
import AsyncCreateNoteContainer from './modals/AsyncCreateNoteContainer';
import AsyncEditIframeContainer from './modals/AsyncEditIframeContainer';
import AsyncAssignDashboardPermissionsDialogContainer from './modals/AsyncAssignDashboardPermissionsDialogContainer';
import AsyncCloneDashboardDialogContainer from './modals/AsyncCloneDashboardDialogContainer';
import AsyncDeleteNonReportWidgetModal from './modals/AsyncDeleteNonReportWidgetModal';
import AsyncActivityLogModal from './modals/AsyncActivityLogModal';
import AsyncRemoveFromDashboardModal from './modals/AsyncRemoveFromDashboardModal';
import AsyncRenameDashboardDialogContainer from './modals/AsyncRenameDashboardDialogContainer';
import AsyncMoveReportModal from './modals/AsyncMoveReportModal';
import LoadingMessage from './shared/LoadingMessage';
import { Tracker } from './Tracker';
import { history } from '../lib/history';
import { initializeUserInfo } from 'dashboard-lib/public/userInfo';
import { NOTE_WIDGET_EDIT, IFRAME_WIDGET_EDIT, DELETE_NON_REPORT_WIDGET } from '../constants/dialogTypes';
import EmailDashboardDialogContainer from './modals/EmailDashboard/EmailDashboardDialogContainer';
import { ReportingActionsErrorBoundary } from './ReportingActionsErrorBoundary';
import { triggerWootricNPS } from '../lib/triggerWootricSurvey';
import { initializeContentAssistance } from 'dashboard-lib/public/contentAssistance/contentAssistanceReducer';
import { NOT_STARTED } from 'content-assistance-lib/hooks/constants';
import { useContentAssistantSettings } from 'content-assistance-lib/hooks/useContentAssistantSettings';
import { AddContactsModal } from './modals/AddContactsModal';
import { DataSyncModalContainer } from './modals/DataSyncModalContainer';
import { usePlatformDashboardBridge } from './usePlatformDashboardBridge';
import ReportViewer from 'reporting-discover-components/components/create-report/ReportViewer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardBody = () => {
  usePlatformDashboardBridge();
  triggerWootricNPS();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [RouteConfigs.map(createDashboardRoute), /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: '/view',
        search: window.location.search
      }
    })]
  });
};
function renderLoading(userInfoResponse) {
  if (isNil(userInfoResponse)) {
    return /*#__PURE__*/_jsx(LoadingMessage, {});
  } else {
    return /*#__PURE__*/_jsx(UserInfoContext.Provider, {
      value: userInfoResponse,
      children: /*#__PURE__*/_jsx(ReportingActionsLoader, {
        ErrorBoundary: ReportingActionsErrorBoundary,
        additionalDialogs: Object.assign({}, REPORT_ACTION_DIALOGS, DASHBOARD_ACTION_DIALOGS, {
          [NOTE_WIDGET_EDIT]: AsyncCreateNoteContainer,
          [IFRAME_WIDGET_EDIT]: AsyncEditIframeContainer,
          [DASHBOARD_CLONE]: AsyncCloneDashboardDialogContainer,
          [DASHBOARD_REMOVE_REPORT]: AsyncRemoveFromDashboardModal,
          [DASHBOARD_RENAME]: AsyncRenameDashboardDialogContainer,
          [DASHBOARD_SET_PERMISSION]: AsyncAssignDashboardPermissionsDialogContainer,
          [REPORT_MOVE]: AsyncMoveReportModal,
          [VIEW_DASHBOARD_DETAILS]: AsyncDashboardDetailsPanel,
          [SINGLE_REPORT_VIEWER]: AsyncSingleReportViewerModal,
          [VIEW_ACTIVITY_LOG]: AsyncActivityLogModal,
          [DELETE_NON_REPORT_WIDGET]: AsyncDeleteNonReportWidgetModal,
          [EMAIL_DASHBOARD_DIALOG]: EmailDashboardDialogContainer,
          ['ADD_CONTACTS_MODAL']: AddContactsModal,
          ['DATA_SYNC_MODAL']: DataSyncModalContainer,
          ['REPORT_PANEL_TEMPLATE_DIALOG']: ReportViewer
        }),
        children: /*#__PURE__*/_jsx(ShareToSlackPanelLoader, {
          children: /*#__PURE__*/_jsx(Tracker, {
            children: /*#__PURE__*/_jsx(DashboardBody, {})
          })
        })
      })
    });
  }
}
const DashboardComponent = ({
  history: _history
}) => {
  const [userInfoResponse, setUserInfoResponse] = useState(null);
  const platformDispatch = usePlatformDashboardDispatch();
  useEffect(() => {
    const appHistory = _history || history;
    const queryMap = parseAsQueryMap(appHistory);
    setup();
    PortalIdParser.get();
    userInfo().then(userData => {
      store.dispatch(initializeUserInfo(userData));
      setUserInfoResponse(userData);
      AppActions.start();
      showApplicationMessages(queryMap, appHistory);
    });
    store.dispatch(fetchUsers());
    fetchUserAttributes();

    // TODO: Update DashboardUI to depend on platform-dashboard-ui's store slice, and remove local instance of userInfo store
    platformDispatch(fetchUserInfo());
  }, [_history, platformDispatch]);
  const {
    fetch: fetchContentAssistantSettings,
    isCustomerAnalysisEnabled,
    isContentAssistanceEnabled,
    getRequest
  } = useContentAssistantSettings({});
  if (getRequest === NOT_STARTED) {
    fetchContentAssistantSettings();
  }
  store.dispatch(initializeContentAssistance({
    isCustomerAnalysisEnabled,
    isContentAssistanceEnabled
  }));
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: renderLoading(userInfoResponse)
  });
};
export default DashboardComponent;